module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/static_wpf/visa-ac7ab8356844bc9b5282bb09ea21d2e3.svg";